import React, { useState, Children } from 'react';
import { IconMenu2, IconUser, IconLock, IconBell, IconUsers, IconPalette, IconGlobe, IconShieldCheck, IconHelp, IconLogout, IconChevronRight, IconPlus, IconPencil, IconTrash } from '@tabler/icons-react';
import { AddChildModal } from '../components/AddChildModal';
import { ProfilePage } from './ProfilePage';
import { PasswordPage } from './PasswordPage';
import { AppearancePage } from './AppearancePage';
interface SettingsPageProps {
  onMenuOpen?: () => void;
}
interface Child {
  id: string;
  name: string;
  avatar: string;
  birthDate: string;
}
type SettingsView = 'main' | 'profile' | 'password' | 'appearance';
export function SettingsPage({
  onMenuOpen
}: SettingsPageProps) {
  const [currentView, setCurrentView] = useState<SettingsView>('main');
  const [children, setChildren] = useState<Child[]>([{
    id: '1',
    name: 'Sofia',
    avatar: 'https://cdn.magicpatterns.com/uploads/c3jxasi4fCCZ93c9aemubP/adele-shafiee-KCvjle4_4ps-unsplash.jpg',
    birthDate: '2018-03-15'
  }, {
    id: '2',
    name: 'Marco',
    avatar: 'https://cdn.magicpatterns.com/uploads/1EXQ4FkeqG6UuqJKWikck9/tatev-arsh-ZtB5Haz58os-unsplash.jpg',
    birthDate: '2020-07-22'
  }]);
  const [isAddChildModalOpen, setIsAddChildModalOpen] = useState(false);
  const handleAddChild = () => {
    setIsAddChildModalOpen(true);
  };
  const handleAddChildSubmit = (child: {
    name: string;
    birthDate: string;
    avatar?: string;
  }) => {
    const newChild: Child = {
      id: Date.now().toString(),
      name: child.name,
      birthDate: child.birthDate,
      avatar: child.avatar || 'https://via.placeholder.com/150'
    };
    setChildren([...children, newChild]);
  };
  const handleEditChild = (childId: string) => {
    console.log('Edit child:', childId);
    // TODO: Open modal to edit child
  };
  const handleDeleteChild = (childId: string) => {
    console.log('Delete child:', childId);
    // TODO: Show confirmation modal
  };
  const settingsGroups = [{
    title: 'Account',
    items: [{
      id: 'profile',
      icon: IconUser,
      label: 'Profilo personale',
      color: '#AEDAFF'
    }, {
      id: 'password',
      icon: IconLock,
      label: 'Password e Sicurezza',
      color: '#B0EC9C'
    }, {
      id: 'notifications',
      icon: IconBell,
      label: 'Notifiche',
      color: '#FAD88A'
    }]
  }, {
    title: 'Famiglia',
    items: [{
      id: 'family',
      icon: IconUsers,
      label: 'Gestione nucleo',
      color: '#DDD6FE'
    }]
  }, {
    title: 'App',
    items: [{
      id: 'appearance',
      icon: IconPalette,
      label: 'Aspetto',
      color: '#FBCFE8'
    }, {
      id: 'language',
      icon: IconGlobe,
      label: 'Lingua',
      color: '#99F6E4'
    }]
  }, {
    title: 'Supporto',
    items: [{
      id: 'privacy',
      icon: IconShieldCheck,
      label: 'Privacy Policy',
      color: '#FECACA'
    }, {
      id: 'help',
      icon: IconHelp,
      label: 'Centro Assistenza',
      color: '#E5E7EB'
    }]
  }];
  // Show ProfilePage
  if (currentView === 'profile') {
    return <ProfilePage onBack={() => setCurrentView('main')} data-id="element-1178" />;
  }
  // Show PasswordPage
  if (currentView === 'password') {
    return <PasswordPage onBack={() => setCurrentView('main')} data-id="element-1179" />;
  }
  // Show AppearancePage
  if (currentView === 'appearance') {
    return <AppearancePage onBack={() => setCurrentView('main')} data-id="element-1180" />;
  }
  // Show main settings view
  return <>
      <div className="flex flex-col h-full" data-id="element-1181">
        {/* Content */}
        <div className="flex-1 overflow-y-auto px-4 py-4" data-id="element-1182">
          <div className="space-y-6" data-id="element-1183">
            {/* Children Management Section */}
            <div data-id="element-1184">
              <div className="flex items-center justify-between mb-3" data-id="element-1185">
                <h2 className="font-rubik font-semibold text-xs uppercase tracking-wider text-yeppy-text text-opacity-40" data-id="element-1186">
                  I tuoi bambini
                </h2>
                <button onClick={handleAddChild} className="flex items-center gap-2 px-3 py-2 rounded-full bg-white border border-yeppy-text border-opacity-15 transition-colors" data-id="element-1187">
                  <IconPlus className="w-4 h-4 text-yeppy-text" stroke={1.5} data-id="element-1188" />
                  <span className="font-poppins text-sm font-medium text-yeppy-text" data-id="element-1189">
                    Aggiungi
                  </span>
                </button>
              </div>

              <div className="space-y-2" data-id="element-1190">
                {children.map(child => <div key={child.id} className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl px-4 py-3" data-id="element-1191">
                    <div className="flex items-center gap-3" data-id="element-1192">
                      <img src={child.avatar} alt={child.name} className="w-12 h-12 rounded-full object-cover border-2 border-yeppy-text border-opacity-10" data-id="element-1193" />
                      <div className="flex-1 min-w-0" data-id="element-1194">
                        <h3 className="font-poppins font-medium text-sm text-yeppy-text mb-0.5" data-id="element-1195">
                          {child.name}
                        </h3>
                        <p className="font-poppins text-xs text-yeppy-text text-opacity-60" data-id="element-1196">
                          Nato il{' '}
                          {new Date(child.birthDate).toLocaleDateString('it-IT', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric'
                      })}
                        </p>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-1197">
                        <button onClick={() => handleEditChild(child.id)} className="w-9 h-9 rounded-full bg-yeppy-bg flex items-center justify-center transition-colors" aria-label="Modifica" data-id="element-1198">
                          <IconPencil className="w-4 h-4 text-yeppy-text" stroke={1.5} data-id="element-1199" />
                        </button>
                        <button onClick={() => handleDeleteChild(child.id)} className="w-9 h-9 rounded-full bg-yeppy-bg flex items-center justify-center transition-colors" aria-label="Elimina" data-id="element-1200">
                          <IconTrash className="w-4 h-4 text-yeppy-text text-opacity-60" stroke={1.5} data-id="element-1201" />
                        </button>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Settings Sections */}
            {settingsGroups.map(group => <div key={group.title} data-id="element-1202">
                <h2 className="font-rubik font-semibold text-xs uppercase tracking-wider text-yeppy-text text-opacity-40 mb-3" data-id="element-1203">
                  {group.title}
                </h2>
                <div className="space-y-2" data-id="element-1204">
                  {group.items.map(item => <button key={item.id} onClick={() => {
                if (item.id === 'profile') {
                  setCurrentView('profile');
                } else if (item.id === 'password') {
                  setCurrentView('password');
                } else if (item.id === 'appearance') {
                  setCurrentView('appearance');
                } else if (item.id === 'notifications') {
                  console.log('Notifications');
                } else if (item.id === 'family') {
                  console.log('Family');
                } else if (item.id === 'language') {
                  console.log('Language');
                } else if (item.id === 'privacy') {
                  console.log('Privacy');
                } else if (item.id === 'help') {
                  console.log('Help');
                }
              }} className="w-full bg-white border border-yeppy-text border-opacity-10 rounded-2xl px-4 py-3 transition-all text-left" data-id="element-1205">
                      <div className="flex items-center gap-3" data-id="element-1206">
                        <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{
                    backgroundColor: `${item.color}33`
                  }} data-id="element-1207">
                          <item.icon className="w-5 h-5" stroke={1.5} style={{
                      color: item.color
                    }} data-id="element-1208" />
                        </div>
                        <span className="font-poppins text-sm font-medium text-yeppy-text" data-id="element-1209">
                          {item.label}
                        </span>
                      </div>
                      <IconChevronRight className="w-5 h-5 text-yeppy-text text-opacity-30" stroke={1.5} data-id="element-1210" />
                    </button>)}
                </div>
              </div>)}

            {/* Logout Button */}
            <button className="w-full bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-4 flex items-center gap-3 text-left transition-all active:scale-[0.98]" data-id="element-1211">
              <div className="w-10 h-10 rounded-xl bg-red-500 bg-opacity-10 flex items-center justify-center flex-shrink-0" data-id="element-1212">
                <IconLogout className="w-5 h-5 text-red-500" stroke={1.5} data-id="element-1213" />
              </div>
              <span className="font-poppins text-sm font-medium text-red-500" data-id="element-1214">
                Esci
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Add Child Modal */}
      <AddChildModal isOpen={isAddChildModalOpen} onClose={() => setIsAddChildModalOpen(false)} onSubmit={handleAddChildSubmit} data-id="element-1215" />
    </>;
}